import api from '@/api/api';

export const apiIntegrations = {
  namespaced: true,
  state: {
    integrationsList: [],
    loading: false,
    error: null,
  },
  getters: {
    allIntegrations: (state) => state.integrationsList,
    isLoading: (state) => state.loading,
    hasError: (state) => !!state.error,
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
    setError(state, err) {
      state.error = err;
    },
    setIntegrations(state, list) {
      state.integrationsList = list;
    },
    addIntegration(state, item) {
      state.integrationsList.push(item);
    },
    updateIntegrationInList(state, updatedItem) {
      const idx = state.integrationsList.findIndex(i => i.id === updatedItem.id);
      if (idx !== -1) {
        state.integrationsList.splice(idx, 1, updatedItem);
      }
    }
  },
  actions: {
    async fetchIntegrations({ commit }) {
      commit('setLoading', true);
      commit('setError', null);
      try {
        const { data } = await api.getIntegrations();
        commit('setIntegrations', data.data);
      } catch (error) {
        commit('setError', error);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async createIntegration({ commit }, payload) {
      commit('setLoading', true);
      commit('setError', null);
      try {
        const { data } = await api.createIntegration(payload);
        return data;
      } catch (error) {
        commit('setError', error);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async rotateIntegrationKey({ commit }, id) {
      commit('setLoading', true);
      commit('setError', null);
      try {
        const { data } = await api.rotateIntegrationKey(id);
        return data;
      } catch (error) {
        commit('setError', error);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async deactivateIntegration({ commit }, id) {
      commit('setLoading', true);
      commit('setError', null);
      try {
        const { data } = await api.deactivateIntegration(id);
        return data;
      } catch (error) {
        commit('setError', error);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async reactivateIntegration({ commit }, id) {
      commit('setLoading', true);
      commit('setError', null);
      try {
        const { data } = await api.reactivateIntegration(id);
        return data;
      } catch (error) {
        commit('setError', error);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async requestDocsAccess({ commit }) {
      commit('setLoading', true);
      commit('setError', null);
      try {
        const { data } = await api.getApiDocsAccess();

        return data.url
      } catch (error) {
        commit('setError', error);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    }
  }
};
